import { createAction } from 'redux-actions';

export type Path = (string | null)[];

export interface IValue {
  path: Path;
  value: any;
}

export const openModal = (reducerName: string) => createAction(`${reducerName}.OPEN_MODAL`);

export const closeModal = (reducerName: string) => createAction(`${reducerName}.CLOSE_MODAL`);

export const setLoadingItem = <T>(reducerName: string) => createAction<T>(`${reducerName}.SET_LOADING_ITEM`);

export const setDataFromSearchParams = (reducerName: string) =>
  createAction(`${reducerName}.SET_DATA_FROM_SEARCH_PARAMS`);

export const setFieldFilter = (reducerName: string) => createAction(`${reducerName}.SET_FIELD_FILTER`);

export const setLoadingItemDone = <T = number>(reducerName: string) =>
  createAction<T>(`${reducerName}.SET_LOADING_ITEM_DONE`);

export const setLoading = (reducerName: string) => createAction(`${reducerName}.SET_LOADING`);

export const setLoadingDone = (reducerName: string) => createAction(`${reducerName}.SET_LOADING_DONE`);

export const getList = <T>(reducerName: string) => createAction<T>(`${reducerName}.GET_LIST`);

export interface ISetList<I> {
  items: I | null,
  total?: number;
  hasData?: boolean;
}

export const setList = <T>(reducerName: string) => createAction<ISetList<T>>(`${reducerName}.SET_LIST`);
export const setChunkList = <T>(reducerName: string) => createAction<T>(`${reducerName}.SET_CHUNK_LIST`);

export const resetState = (reducerName: string) => createAction(`${reducerName}.RESET_STATE`);

export interface ISetData<Data> {
  data: Data | null,
  hasData?: boolean;
}

export const setData = <T>(reducerName: string) => createAction<ISetData<T>>(`${reducerName}.SET_DATA`);

export const setLoadingItemPrimitive = <T = number>(reducerName: string) =>
  createAction<T>(`${reducerName}.SET_LOADING_ITEM_PRIMITIVE`);

export const changePropState = (reducerName: string, injVal?: any, injPath?: Path) =>
  createAction(
    `${reducerName}.CHANGE_PROP_STATE`,
    (path: Path, value: any): IValue => ({ path: injPath || path, value: injVal || value })
  );

export const changePropStateMulti = (reducerName: string) =>
  createAction(`${reducerName}.CHANGE_PROP_STATE_MULTI`, (values: IValue[]): IValue[] => values);

export const setDateFieldFilter = (reducerName: string) => createAction(`${reducerName}.SET_DATE_FIELD_FILTER`);
export const setPeriodFieldFilter = (reducerName: string) =>
  createAction(`${reducerName}.SET_DATE_PERIOD_FIELD_FILTER`);
